import {Filters} from 'src/modules/events/typedefs';
import {RootState} from 'src/store/store';

export const getEventsFilters = (state: RootState): Filters => state.eventsFilters.data;
